module.exports = __webpack_public_path__ + "static/media/Colette Queen Bed Base - 155x205 cm_Grey.530e1c89.png";